module.exports = __webpack_public_path__ + "img/idealism--relativism--and-realism-cover.4cab569f.jpg";